import React, { PropTypes } from 'react';
import EditableSection from 'project/containers/brief_editable_section';
import { getVisibleBriefQuestions } from 'pap/utils';

/**
 * Background brief section.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Background = ({ project, sensitive, canEdit }) => {
  const briefQuestions = getVisibleBriefQuestions(project);
  const questions = ['description'].concat(sensitive? [] : ['industry', 'company']);
  const items = briefQuestions.filter(q => questions.includes(q.name));

  return (<EditableSection
    title="Background"
    canEdit={canEdit}
    items={items}
    project={project}
  />);
};

Background.propTypes = {
  project: PropTypes.object.isRequired,
  sensitive: PropTypes.bool,
  canEdit: PropTypes.bool,
};

export default Background;



// WEBPACK FOOTER //
// ./project/components/brief/background.jsx